var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00004 14.0008H14M9.75933 6.83948L12.9793 5.97682C13.1496 5.92763 13.3281 5.9129 13.5041 5.93349C13.6802 5.95407 13.8504 6.00956 14.0048 6.09671C14.1591 6.18385 14.2946 6.30091 14.4032 6.44102C14.5118 6.58114 14.5913 6.7415 14.6372 6.91273C14.6831 7.08396 14.6943 7.26262 14.6704 7.43826C14.6464 7.6139 14.5876 7.78299 14.4975 7.93564C14.4073 8.0883 14.2877 8.22145 14.1455 8.3273C14.0033 8.43316 13.8414 8.5096 13.6693 8.55215L4.01 11.1408L1.04333 7.79415L2.97467 7.27682L4.608 8.21948L6.53933 7.70215L4.044 3.53948L5.976 3.02148L9.75933 6.83948Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.7dc38c779eb5bf700e32071d93a00e1c.svg";
export { ForwardRef as ReactComponent };